<template>
<!--  7:14-->
  <div>
    <cancel-heading is-centered>Subscription Cancelled</cancel-heading>
    <cancel-content is-centered>You won't be billed again.</cancel-content>
    <cancel-content>And if you just realized that you made a big mistake, shoot us an email at support@forefrontcrm.com or call (210) 610-6683 before it's too late</cancel-content>
    <cancel-icon/>
  </div>
</template>

<script>
import CancelHeading from "./components/CancelHeading.vue";
import CancelContent from "./components/CancelContent.vue";
import CancelIcon from "./components/CancelIcon.vue";

export default {
  name: "CancelConfirmation",
  components: {CancelIcon, CancelContent, CancelHeading}
}
</script>
